import { render } from "./DeepPerformanceCpuDataUpload.vue?vue&type=template&id=21e97a8a&scoped=true&ts=true"
import script from "./DeepPerformanceCpuDataUpload.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceCpuDataUpload.vue?vue&type=script&lang=ts"

import "./DeepPerformanceCpuDataUpload.vue?vue&type=style&index=0&id=21e97a8a&scoped=true&lang=css"
import "./DeepPerformanceCpuDataUpload.vue?vue&type=style&index=1&id=21e97a8a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e97a8a"]])

export default __exports__